module.exports = __webpack_public_path__ + "static/media/send-an-offer.5ba90eba.mp4";